export default {
    mounted(el) {
        el.addEventListener('copy', (event) => event.preventDefault());
        el.addEventListener('cut', (event) => event.preventDefault());
        el.addEventListener('paste', (event) => event.preventDefault());
        el.addEventListener('contextmenu', (event) => event.preventDefault());
    }
};